import * as z from "zod/v4";

export const deleteWorkOrderFlow = {
  name: "deleteWorkOrderFlow" as const,
  input: z.object({ flowId: z.string() }),
  output: z.object({ success: z.boolean() }),
};
